import { darken } from 'polished';
import styled from 'styled-components';

import { Div, P } from 'common/styles/oc-styled-components';
import { BREAKPOINTS, colors } from 'common/styles/style-constants';
import { Modal } from 'opencare-crown';

import { Link } from '../../../checkout-styled-components';

export const CustomStyledAlert = styled(Div)`
  && {
    padding: 8px 15px;
    height: auto;
    background: rgba(80, 124, 117, 0.05);
    border: 1px solid ${colors.sage7};
    color: ${colors.sage7};
    border-radius: 3px;
    font-size: 12px;
    text-align: center;

    a {
      color: ${colors.sage7};
    }
  }
`;

export const Fieldset = styled.fieldset`
  margin: ${(props) => props.margin};
`;

export const InsuranceLabel = styled(P)`
  color: ${colors.ash};
  font-size: 12px;
  min-width: 70px;
`;

export const MemberIdHelperButton = styled(P)`
  border-bottom: 1px solid ${colors.blue};
  display: inline-block;

  &:hover {
    border-bottom: 1px solid ${darken(0.1, colors.blue)};
    font-weight: 400;
    cursor: pointer;
  }
`;

export const HoldEdit = styled.button`
  align-items: center;
  border: 1px solid ${colors.ash};
  border-radius: 50%;
  display: flex;
  height: 30px;
  justify-content: center;
  margin: 0 10px 0 0;
  outline: none;
  width: 30px;
`;

export const SageLink = styled(Link)`
  font-weight: 600;
  color: ${colors.sageDark};
  border-color: ${colors.sageDark};
`;

export const StyledModal = styled(Modal)`
  && {
    min-width: 600px;
    @media (max-width: ${BREAKPOINTS.mobileMax}px) {
      min-width: 0px;
    }

    &.ant-modal {
      @media (max-width: ${BREAKPOINTS.mobileMax}px) {
        height: 100vh;
        margin: 0;
        max-width: 100vw;
        top: 0;
        width: 100vw;
      }
    }

    .ant-modal-body {
      min-width: 600px;
      @media (max-width: ${BREAKPOINTS.mobileMax}px) {
        min-width: 0px;
        height: 100vh;
      }
    }

    .ant-modal-content {
      @media (max-width: ${BREAKPOINTS.mobileMax}px) {
        border-radius: 0;
        height: 100vh;
        width: 100vw;
      }
    }
  }
`;

export const StyledModalCanada = styled(Modal)`
  && {
    min-width: 750px;
    @media (max-width: ${BREAKPOINTS.mobileMax}px) {
      min-width: 0px;
    }

    &.ant-modal {
      @media (max-width: ${BREAKPOINTS.mobileMax}px) {
        width: 100vw;
        max-width: 100vw;
        height: 100%;
        min-height: 100vh;
        margin: 0;
        top: 0;
      }
    }

    .ant-modal-body {
      min-width: 750px;
      @media (max-width: ${BREAKPOINTS.mobileMax}px) {
        min-width: 0px;
        height: 100%;
        min-height: 100vh;
      }
    }

    .ant-modal-content {
      @media (max-width: ${BREAKPOINTS.mobileMax}px) {
        min-height: 100vh;
        width: 100vw;
        border-radius: 0;
      }
    }
  }
`;

export const MemberIdModal = styled(Modal)`
  && {
    @media (max-width: ${BREAKPOINTS.mobileMax}px) {
      min-width: 0px;
    }

    &.ant-modal {
      @media (max-width: ${BREAKPOINTS.mobileMax}px) {
        width: 100vw;
        max-width: 100vw;
        height: 100vh;
        margin: 0;
        top: 0;
      }
    }

    .ant-modal-body {
      width: 400px;
      @media (max-width: ${BREAKPOINTS.mobileMax}px) {
        max-width: 100%;
        height: 100%;
        min-height: 100vh;
        background: ${colors.white};
      }
    }

    .ant-modal-content {
      width: 400px;
      margin: 0 auto;

      @media (max-width: ${BREAKPOINTS.mobileMax}px) {
        width: 100vw;
        min-height: 100vh;
        border-radius: 0;
      }
    }
  }
`;

export const OpacityDiv = styled.div`
  display: block;
  transition: all 0.3s ease-in-out;
  &.hidden {
    display: none;
  }
`;
